import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const StyledLink = styled(Link)`
    font-weight: 500;
    line-height: 20px;
`;

/**
 * Custom link with arrow icon
 *
 * @param {Object} props
 * @param {string} props.to destination
 * @param {React.Component} props.children children
 * @returns {React.Component} The component
 */
export function GoLink({ to, children }) {
    return (
        <StyledLink to={to}>
            {children} <FiArrowRight />
        </StyledLink>
    );
}

export default GoLink;
